module.exports = __webpack_public_path__ + "assets/img/tx213_2.ca29ce14.jpg";